/* eslint-disable react/no-danger */
import { GridExpandMoreIcon } from "@mui/x-data-grid-pro";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Divider,
  Grid2,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "components";
import { groupBy } from "lodash";
import React from "react";
import { moneyCommaSeparator, numberToCurrency } from "utils";

const CalculationPage = ({ calculationData }: any) => {
  const tableCellStyle = {
    padding: "8px !important",
  };

  const renderCalculationTable = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 8,
        }}
      >
        {calculationData?.feeplanDetails?.map((dataItem: any) => {
          return (
            <Card
              sx={{
                p: 2,
                width:
                  calculationData?.feeplanDetails.length === 1 ? "100%" : "50%",
                background: "#F8FAFC",
              }}
            >
              <Grid2 container>
                <Grid2 size={8}>
                  <Typography fontSize={16} fontWeight={600}>
                    {`${dataItem?.feeplanName} - ${dataItem?.revenueProductName}` ||
                      "-"}
                  </Typography>
                  <Typography
                    py={"8px"}
                    fontSize={12}
                    display={"flex"}
                    alignItems={"center"}
                    gap={1}
                  >
                    Fee
                    <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                      {dataItem?.feeType === "FIXED"
                        ? moneyCommaSeparator(dataItem?.fee)
                        : `${dataItem?.fee}%`}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12}>
                    {`${dataItem?.startDate}-${dataItem?.endDate}`}
                  </Typography>
                </Grid2>
                <Grid2
                  size={4}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                >
                  <Typography fontSize={24} fontWeight={600}>
                    {numberToCurrency(dataItem?.amount?.totalFee || 0)}
                  </Typography>
                </Grid2>
              </Grid2>
            </Card>
          );
        })}
      </div>
    );
  };

  const ParentAccordion = styled(Accordion)(() => {
    return {
      borderRadius: "14px !important",
      border: `1px solid #E1E8F1`,
      "& .MuiAccordion-root:before": {
        backgroundColor: "transparent !important",
      },
    };
  });

  const renderAnnexure = () => {
    const annexureData = calculationData?.feeplanDetails?.map(
      (dataItem: any) => dataItem?.annexureDetails?.length ?? 0,
    );

    if (annexureData?.some((length: any) => length === undefined)) return null;

    return (
      <Grid2 size={12} my={1}>
        {Object.entries(groupBy(calculationData?.feeplanDetails, "feeplanName"))
          ?.map(([key, val]) => {
            return {
              plan: key,
              data: val,
            };
          })
          .map((planData, planIndex) => {
            return (
              <React.Fragment key={planIndex}>
                {planData?.data?.map((dataItem, index) => {
                  if (!dataItem?.annexureDetails?.length) return null;

                  return (
                    <ParentAccordion>
                      <AccordionSummary
                        expandIcon={<GridExpandMoreIcon />}
                        aria-controls={`panel${index + 1}-content`}
                        id={`panel${index + 1}-header`}
                        sx={{
                          fontSize: "14px",
                          fontWeight: 700,
                          "& .MuiAccordionSummary-content": {
                            margin: 0,
                          },
                        }}
                      >
                        <Typography fontSize={16} fontWeight={600}>
                          {`Annexure - ${planData?.plan} - ${dataItem?.revenueProductName}` ||
                            "Plan"}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{
                          padding: 0,
                          "& .MuiTableContainer-root": {
                            border: "none",
                            maxHeight: "530px",
                            overflowY: "auto",
                          },
                        }}
                      >
                        <TableContainer>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell style={{ padding: 16 }}>
                                  {dataItem?.revenueProductName ===
                                  "Management Fee"
                                    ? "Date Period"
                                    : "Particulars"}
                                </TableCell>
                                {dataItem?.revenueProductName ===
                                  "Management Fee" && (
                                  <TableCell
                                    align="center"
                                    style={{ padding: 16 }}
                                  >
                                    Calculation
                                  </TableCell>
                                )}
                                <TableCell
                                  align="center"
                                  style={{ padding: 16 }}
                                >
                                  Fee
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* ADVANCE Header */}
                              {dataItem?.calculationMethod === "advance" && (
                                <TableRow>
                                  <TableCell
                                    sx={{
                                      ...tableCellStyle,
                                      padding: "16px !important",
                                      color: "var(--black)",
                                      background: `var(--primary-50)`,
                                    }}
                                    component="th"
                                    scope="row"
                                  >
                                    <Typography
                                      fontWeight={600}
                                      color={"var(--black)"}
                                    >
                                      Advance Collected
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...tableCellStyle,
                                      padding: "16px !important",
                                      color: "var(--black)",
                                      background: `var(--primary-50)`,
                                    }}
                                    component="th"
                                    scope="row"
                                  />
                                  <TableCell
                                    align="center"
                                    sx={{
                                      ...tableCellStyle,
                                      padding: "16px !important",
                                      color: "var(--black)",
                                      background: `var(--primary-50)`,
                                    }}
                                    component="th"
                                    scope="row"
                                  >
                                    <Typography
                                      fontWeight={600}
                                      color={"var(--black)"}
                                    >
                                      {numberToCurrency(
                                        dataItem?.outstandingAdvanceAmount || 0,
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )}

                              {dataItem?.annexureDetails?.map(
                                (annexureData: any, index: number) => {
                                  return (
                                    <TableRow
                                      key={index}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell
                                        sx={{
                                          ...tableCellStyle,
                                          padding: "16px !important",
                                        }}
                                        component="th"
                                        scope="row"
                                      >
                                        <Grid2 container>
                                          <Grid2
                                            size={12}
                                            display="flex"
                                            color={"var(--black)"}
                                            fontWeight={
                                              annexureData?.feeInputs ===
                                              "MANAGEMENT FEE TOTAL"
                                                ? 600
                                                : 400
                                            }
                                          >
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: annexureData?.feeInputs,
                                              }}
                                            />
                                          </Grid2>
                                          <Grid2
                                            size={12}
                                            display="flex"
                                            color={"#545864"}
                                            fontWeight={400}
                                          >
                                            {annexureData?.startDate}
                                          </Grid2>
                                        </Grid2>
                                      </TableCell>

                                      {dataItem?.revenueProductName ===
                                        "Management Fee" && (
                                        <TableCell
                                          sx={{
                                            ...tableCellStyle,
                                            padding: "16px !important",
                                            fontWeight: 400,
                                          }}
                                          component="th"
                                          scope="row"
                                        >
                                          <Grid2 container spacing={0.5}>
                                            <Grid2
                                              size={12}
                                              display="flex"
                                              justifyContent="center"
                                              color={"var(--black)"}
                                            >
                                              {annexureData?.calculationTotal}
                                            </Grid2>
                                            {annexureData?.feeInputs !==
                                              "MANAGEMENT FEE TOTAL" && (
                                              <Grid2
                                                size={12}
                                                display={"flex"}
                                                justifyContent={"center"}
                                                color={"var(--black)"}
                                              >
                                                <Divider
                                                  sx={{
                                                    borderColor:
                                                      "var(--neutral-500)",
                                                    width: "150px",
                                                  }}
                                                />
                                              </Grid2>
                                            )}
                                            <Grid2
                                              size={12}
                                              display="flex"
                                              justifyContent="center"
                                              color={"var(--black)"}
                                            >
                                              {annexureData?.totalDays}
                                            </Grid2>
                                          </Grid2>
                                        </TableCell>
                                      )}
                                      <TableCell
                                        align="center"
                                        sx={{
                                          tableCellStyle,
                                          padding: "16px !important",
                                        }}
                                        component="th"
                                        scope="row"
                                      >
                                        <Typography
                                          color={"var(--black)"}
                                          fontWeight={
                                            annexureData?.feeInputs ===
                                            "MANAGEMENT FEE TOTAL"
                                              ? 600
                                              : 400
                                          }
                                        >
                                          {annexureData?.totalAmount}
                                          {/* {numberToCurrency(
                                            +annexureData?.totalAmount,
                                          )} */}
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  );
                                },
                              )}

                              {/* ADVANCE Footer */}
                              {dataItem?.calculationMethod === "advance" && (
                                <TableRow>
                                  <TableCell
                                    sx={{
                                      ...tableCellStyle,
                                      padding: "16px !important",
                                      color: "var(--black)",
                                      background: `var(--primary-50)`,
                                    }}
                                    component="th"
                                    scope="row"
                                  >
                                    <Typography
                                      fontWeight={600}
                                      color={"var(--black)"}
                                    >
                                      Advance Fee
                                    </Typography>
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...tableCellStyle,
                                      padding: "16px !important",
                                      color: "var(--black)",
                                      background: `var(--primary-50)`,
                                    }}
                                    component="th"
                                    scope="row"
                                  />
                                  <TableCell
                                    align="center"
                                    sx={{
                                      ...tableCellStyle,
                                      padding: "16px !important",
                                      color: "var(--black)",
                                      background: `var(--primary-50)`,
                                    }}
                                    component="th"
                                    scope="row"
                                  >
                                    <Typography
                                      fontWeight={600}
                                      color={"var(--black)"}
                                    >
                                      {numberToCurrency(
                                        dataItem?.advanceFeeAmount || 0,
                                      )}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </ParentAccordion>
                  );
                })}
              </React.Fragment>
            );
          })}
      </Grid2>
    );
  };

  // const renderCashTransaction = () => {
  //   if (!calculationData?.cashTransaction?.length) return null;

  //   return (
  //     <Grid2 size={4}>
  //       <TableContainer>
  //         <Table>
  //           <TableHead>
  //             <TableRow>
  //               <TableCell colSpan={3} sx={{ padding: "16px !important" }}>
  //                 <Typography fontSize={18} fontWeight={600} color={"var(--black)"}>
  //                   Cash Flows
  //                 </Typography>
  //               </TableCell>
  //             </TableRow>
  //           </TableHead>
  //           <TableHead>
  //             <TableRow>
  //               <TableCell sx={{ padding: "8px !important" }}>Date</TableCell>
  //               <TableCell sx={{ padding: "8px !important" }}>
  //                 Transaction Type
  //               </TableCell>
  //               <TableCell sx={{ padding: "8px !important" }}>Amount</TableCell>
  //             </TableRow>
  //           </TableHead>
  //           <TableBody>
  //             {calculationData?.cashTransaction.map(
  //               (dataItem: any, index: number) => (
  //                 <TableRow
  //                   key={index}
  //                   sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
  //                 >
  //                   <TableCell
  //                     sx={{
  //                       ...tableCellStyle,
  //                       color: "var(--black)",
  //                       fontWeight: 400,
  //                     }}
  //                     component="th"
  //                     scope="row"
  //                   >
  //                     <Typography
  //                       color={"var(--black)"}
  //                       fontWeight={400}
  //                     >
  //                       {dayjs(dataItem?.date).format("DD-MM-YYYY")}
  //                     </Typography>
  //                   </TableCell>
  //                   <TableCell
  //                     sx={{
  //                       ...tableCellStyle,
  //                       color:
  //                         dataItem?.transactionType === "WITHDRAW"
  //                           ? `var(--warning-700)`
  //                           : "var(--success-700)",
  //                     }}
  //                     component="th"
  //                     scope="row"
  //                   >
  //                     <Typography
  //                       color={"var(--black)"}
  //                       fontWeight={400}
  //                     >
  //                       {dataItem?.transactionType || "-"}
  //                     </Typography>
  //                   </TableCell>
  //                   <TableCell
  //                     sx={{ ...tableCellStyle, color: "var(--black)" }}
  //                     component="th"
  //                     scope="row"
  //                   >
  //                     <Typography
  //                       color={"var(--black)"}
  //                       fontWeight={400}
  //                     >
  //                       {numberToCurrency(dataItem?.billAmount)}
  //                     </Typography>
  //                   </TableCell>
  //                 </TableRow>
  //               )
  //             )}
  //           </TableBody>
  //         </Table>
  //       </TableContainer>
  //     </Grid2>
  //   );
  // };

  return (
    <>
      <Grid2 container spacing={1}>
        <Grid2 size={12}>{renderCalculationTable()}</Grid2>
        {renderAnnexure()}
        {/* {renderCashTransaction()} */}
      </Grid2>
    </>
  );
};

export default CalculationPage;
